<div class="admin-layout">

  <a class="admin-skip-link" href="#admin-main">Ir para o conteúdo principal</a>

  <dx-drawer
    class="admin-drawer"
    template="navigationTemplate"
    [(opened)]="sidebarOpen"
    openedStateMode="shrink"
    position="left"
    revealMode="slide"
    [shading]="false">

    <div *dxTemplate="let data of 'navigationTemplate'" class="admin-drawer-nav">
      <admin-sidenav></admin-sidenav>
    </div>

    <div class="admin-shell">
      <admin-toolbar
        [sidebarOpen]="sidebarOpen()"
        (toggleSidebar)="toggleSidebar()">
      </admin-toolbar>

      <main id="admin-main" class="admin-canvas" role="main">
        <router-outlet />
      </main>
    </div>

  </dx-drawer>

</div>
